<template>
  <div class="sort-column">

    <div class="sort-column__asc" :class="{'sort-column_active' : isAsc}" @click.stop="sort(isAsc ? 'clear': 'asc')">
      <span class="sort-column__subtitle">Sort by Ascending</span>
      <span class="sort-column__direction">{{ascTitle}}</span>
    </div>
    <div class="sort-column__desc" :class="{'sort-column_active' : isDesc}" @click.stop="sort(isDesc? 'clear': 'desc')">
      <span class="sort-column__subtitle">Sort by Descending</span>
      <span class="sort-column__direction">{{descTitle}}</span>
    </div>

  </div>
</template>

<script>
  import BaseMultiSelectSortableHeader from "./BaseMultiSelectSortableHeader";

/**
 * component is used in {@link BaseMultiSelectSortableHeader} for sorting
 */
export default {
  name: 'BaseSortableHeader',
  props: {
    label: {
      type: String,
      required: true,
      default: 'Sort'
    },
    /**
     * specific property
     * */
    propName: {
      type: String,
      required: true
    },
    /**
     * is sorting values Number or not
     */
    isNumber: {
      type: Boolean,
      default: false
    },
    /**
     * general sort config array
     */
    sortConfig: {
      type: Array
    },
    sortDirection: String,
    sortColumn: String
  },
  computed: {
    thisColumnInConfig () {
      if (this.sortConfig) {
        return this.sortConfig.find(config => config.propertyName === this.propName)
      }
    },
    isAsc () {
      if (this.thisColumnInConfig) {
        return this.thisColumnInConfig && this.thisColumnInConfig.sortDirection === 'asc'
      }
      return this.sortColumn === this.propName && this.sortDirection === 'asc'
    },
    isDesc () {
      if (this.thisColumnInConfig) {
        return this.thisColumnInConfig && this.thisColumnInConfig.sortDirection === 'desc'
      }
      return this.sortColumn === this.propName && this.sortDirection === 'desc'
    },
    ascTitle () {
      return this.isNumber ? '0 -> 100' : 'A -> Z'
    },
    descTitle () {
      return this.isNumber ? '100 -> 0' : 'Z -> A'
    }
  },
  methods: {
    sort (direction) {
      this.$emit('sort', direction)
    },
    reset () {
      if (this.thisColumnInConfig && this.thisColumnInConfig.sortDirection) {
        this.$emit('sort', 'clear')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  span {
    user-select: none;
  }

  .sort-column {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-gap: 5px;
    grid-template-areas: "asc" "desc";
    font-size: 12px;
    font-weight: normal;
    padding: 5px;

    &__asc,
    &__desc {
      grid-area: desc;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-areas: 'subtitle direction';
      cursor: pointer;
    }

    &__asc {
      grid-area: asc;
      margin-bottom: 5px;
    }

    &_active {
      color: $rfx-bright-blue;
    }

    &_center {
      margin: 0;
    }

    &__subtitle {
      grid-area: subtitle;
      user-select: none;
    }

    &__direction {
      grid-area: direction;
      text-align: center;
      font-weight: bold;
      user-select: none;

    }

  }

</style>
